<app-shared-filters-v2 (scrollToTop)="scrollToTop()"></app-shared-filters-v2>

<div *ngIf="isMobile" class="mobile-home-screen">
  <app-home-mobile
    [loading]="loading"
    [properties]="properties"
  ></app-home-mobile>
</div>

<ng-container *ngIf="!isMobile">
  <div class="desktop-wrapper">
    <div class="sidebar-wrapper">
      <app-profile-sidebar [useCollapsed]="true"></app-profile-sidebar>
    </div>

    <div class="home-map-screen">
      <app-home-map-view
        class="left"
        [loading]="loading"
        [properties]="properties"
      ></app-home-map-view>
      <div #listViewContainer class="list-view-container">
        <app-home-list-view
          [loading]="loading"
          [properties]="properties"
          [isLoggedIn]="isLoggedIn"
        ></app-home-list-view>
      </div>
    </div>
  </div>
</ng-container>
